import { User, ItineraryHero } from '@/models'

export const isItineraryHero = (hero: User | ItineraryHero | null): hero is ItineraryHero => {
  return !!hero && typeof hero === 'object' && 'overrideHeroBioDisplay' in hero
}

export const isUser = (hero: User | ItineraryHero | null): hero is User => {
  return !!hero && typeof hero === 'object' && 'bio' in hero && 'id' in hero
}
